export const messageDateCheck = (timestamp) => {
  const dateToday = new Date().toDateString();
  const receivedDate = new Date(timestamp * 1000).toDateString();

  if (dateToday === receivedDate) {
    return "Today";
  }
  return receivedDate;
};
